<template>
	<!-- 人员管理 -->
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item  v-if="bquery&&cityFix">
					<el-select v-model="filters.dvalue"  clearable placeholder="请选择区" >
						<el-option v-for="item in doptions" :key="item.Mpid" :label="item.MpCn" :value="item.MpValue"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="bquery">
					<el-input v-model="filters.companyName" placeholder="企业名称"></el-input>
				</el-form-item>
        		<el-form-item>
					<el-input v-model="filters.workerName" placeholder="姓名"></el-input>
				</el-form-item>
        		<el-form-item>
					<el-input v-model="filters.phone" placeholder="手机号码"></el-input>
				</el-form-item>
        		<el-form-item>
					<el-input v-model="filters.widNo" placeholder="身份证号"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="getMemberList">查询</el-button>
				</el-form-item>
				<el-form-item v-if="bshow">
					<el-button type="success" v-on:click="showAddry">新增人员</el-button>
				</el-form-item>
				<el-form-item v-if="bquery">
					<el-button type="warning" @click="handledc" :loading="dcLoading">导出</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="memberlist" highlight-current-row v-loading="listLoading"  style="width: 100%;">
			<el-table-column prop="name" label="姓名" min-width="100" align="center">
			</el-table-column>

      		<el-table-column label="性别" align="center" min-width="80" >
				<template slot-scope="scope">
				<span>{{scope.row.sex==='0'?'女':"男"}}</span>
				</template>
			</el-table-column>

			<el-table-column prop="widNo" label="身份证号" align="center"  min-width="150">
			</el-table-column>

			<el-table-column prop="phone" label="手机号" align="center"  min-width="120">
		 	</el-table-column>

			<el-table-column label="合同状态" align="center" min-width="150" >
				<template slot-scope="scope">
				<!-- 不同状态显示不同颜色的文字 -->
				<div v-if='scope.row.laborContract==="0"'>
					<span style="color: red;">未签订</span>
				</div>
					
				<div v-else>
					<span style="color: green;">已签订</span>
				</div>
				</template>
			</el-table-column>

			<el-table-column label="保险状态" align="center" min-width="100" >
				<template slot-scope="scope">
				<div v-if='scope.row.buyInsurance==="0"'>
					<span style="color: red;">未购买</span>
				</div>
					
				<div v-else>
					<span>{{scope.row.insurancetypeName}}</span>
				</div>
				</template>
			</el-table-column>

			<el-table-column prop="workerTypeName" label="岗位" align="center" min-width="120">
			</el-table-column>

			<el-table-column prop="enterDate" label="入职日期" align="center" min-width="120">
			</el-table-column>
			
			<el-table-column prop="coName" label="所属企业"  align="center" min-width="180">
		 	</el-table-column>

			<el-table-column v-if="bshow" label="操作"  align="left" width="250">
				<template slot-scope="scope">
          			<el-button type="warning" size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
					<el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total,prev, pager, next" @current-change="handleCurrentChange" :page-size="20" :total="total" style="float:right;">
			</el-pagination>
		</el-col>

		<!--编辑-->
		<el-dialog :title="editFormTitle" v-model="editFormVisible" :close-on-click-modal="false">
			
			<el-form :model="editForm" label-width="100px" :rules="editFormRules" ref="editForm">
			<el-row>
				<el-col :span="11">
					<el-form-item label="手机号" prop="phone">
						<el-input v-model="editForm.phone" auto-complete="off"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="11" >      
					<el-form-item label="岗位" >
						<el-select v-model="gwvalue" placeholder="请选择" >
							<el-option v-for="item in gwoptions" :key="item.Mpid" :label="item.MpCn" :value="item.MpValue"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editMember" :loading="editLoading">保存</el-button>
			</div>
		</el-dialog>

		<el-dialog title="新增人员" v-model="addryFormVisible" :close-on-click-modal="false" >
			<el-form :label-position="labelPosition" :model="addryForm" label-width="120px" :rules="addryFormRules" ref="addryForm">
				<el-row>
				<el-col :span="11">
					<el-form-item label="姓名" prop="name">
						<el-input v-model="addryForm.name" auto-complete="off"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="11" >      
					<el-form-item label="身份证号" prop="widNo">
						<el-input v-model="addryForm.widNo" auto-complete="off"></el-input>
					</el-form-item>
				</el-col>
			    </el-row>
				<el-row>
				<el-col :span="11">
					<el-form-item label="手机号" prop="phone">
						<el-input v-model="addryForm.phone" auto-complete="off"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="11" >      
					<el-form-item label="人员岗位" >
						<el-select v-model="gwvalue" placeholder="请选择" >
							<el-option v-for="item in gwoptions" :key="item.Mpid" :label="item.MpCn" :value="item.MpValue"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
			    </el-row>
				<el-row>
					<el-col :span="11">
						<el-form-item label="劳动合同" >
							<el-select v-model="addryForm.laborContract" placeholder="请选择">
								<el-option v-for="item in laboroptions" :key="item.value" :label="item.label" :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="11" >      
						<el-form-item label="入职日期" prop="enterDate">
							<el-date-picker v-model="addryForm.selEnterDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
						</el-form-item>
					</el-col>
			    </el-row>
				 <el-row>
					<el-col :span="11">
						<el-form-item label="人员保险" >
						<el-select v-model="addryForm.buyInsurance" placeholder="请选择">
							<el-option v-for="item in insuranceoptions" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
						</el-form-item>
					</el-col>
			    </el-row>
				 <el-row v-if="addryForm.buyInsurance=='1'" >
					 <!-- 外层包裹div，彻底隔离样式 -->
          			<div class="checkbox-wrapper">
					<el-form-item label="保险类别" >
						<el-checkbox-group v-model="bxselectedValues" >
							<el-checkbox v-for="item in bxoptions" :key="item.Mpid" :label="item.MpValue" class="checkbox-item">
								{{ item.MpCn }}
							</el-checkbox>
						</el-checkbox-group>
					</el-form-item>
					</div>
			    </el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="addryFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="handleAddry">提交</el-button>
			</div>
		</el-dialog>

	</section>
</template>

<script>
	import {memberPageList,memberPageListdc,editMemberInfo,deleteMember,addMember,getparamsByType} from '../../api/api';
	let moment = require("moment");
	export default {
		data() {
			return {
				objectId:0, //当前登录的用户id
				coId:0, //当前登录的用户企业id

				bquery:false,//管理员权限
				bshow:false,//是否显示操作按钮

				filters: {
					companyName: '',
					workerName:"",
					phone:"",
					widNo:"",
					dvalue:'',
				},
				memberlist: [],
				total: 0,
				page: 1,
				listLoading: false,

				//编辑信息
				editFormTitle:'',  //编辑的时候，显示人员姓名
				editFormVisible: false, 
				editLoading: false,
				editFormRules: {
					phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
				},
				
				editForm: {
					workerId:'',

					phone:"",
					workerType:"",
					loginname:"",
					loginpwd:"",
				},

				//新增人员
				addryFormVisible: false, 
				addryFormRules: {
					name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
					widNo: [{ required: true, message: "请输入身份证号", trigger: "blur" }],
					phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
					enterDate: [{ required: true, message: "请选择入职时间", trigger: "blur" }]
				},
				
				addryForm: {
					createUserId:0,
					coId:0,

					name:"",
					widNo:"",
					phone:"",
					workerType:"",
					loginname:"",
					loginpwd:"",

					laborContract: '0',
					buyInsurance: '0',
					insurancetype: '',
					enterDate:'',
					selEnterDate:null,	
				},
				gwoptions: [],
				gwvalue:'',

				labelPosition: 'right',
			
				//快递人员保险，多选
				bxoptions: [],
				bxselectedValues:[],

				insuranceoptions: [
					{
						value: '0',
						label: '未购买'
					}, 
					{
						value: '1',
						label: '已购买'
					}
				],
				
				laboroptions: [
					{
						value: '0',
						label: '未签订'
					}, 
					{
						value: '1',
						label: '已签订'
					}
				],
				//市局管理员支持区查询功能
				doptions: [],
				cvalue:'',
				cvalueid:'',
				cityFix:false,

				//要导出的数据list
				exportList: [],
				dcLoading: false
				//end
			}
		},
		methods: {
			isValidIdCard(idCard) {
				const regex = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[\dXx]$/;
				if (!regex.test(idCard)) {
					return false;
				}
				const coefficient = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
				const checkCode = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
				let sum = 0;
				for (let i = 0; i < 17; i++) {
					sum += parseInt(idCard[i], 10) * coefficient[i];
				}
				const mod = sum % 11;
				const lastChar = idCard[17].toUpperCase(); // 将最后一位转为大写，以支持大小写混合的X
				return checkCode[mod] === lastChar;
			},

			isValidatePhone(phonenumber){
				// 手机号正则表达式
				const regphone = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
				// 验证手机号
				if (!regphone.test(phonenumber)) {
					return false
				} else {
					return true
				}
			},

			showAddry: function (index, row) {
				this.addryForm={
					createUserId:this.objectId,
					coId: this.coId,
					name:"",
					widNo:"",
					phone:"",
					workerType:"",
					loginname:"",
					loginpwd:"",
					laborContract: '0',
					buyInsurance: '0',
					insurancetype: '',
					enterDate:'',
					selEnterDate:null,	
				},
				this.bxselectedValues=[]
				this.gwvalue=this.gwoptions[0].MpValue
				this.addryFormVisible=true
			},
			handleAddry: function () {
          		//入职时间
				if(this.addryForm.selEnterDate!=null){
					this.addryForm.enterDate = this.addryForm.selEnterDate.toLocaleString();
				}
				if(this.addryForm.enterDate==""){
					this.$message.error("请选择人员的入职时间");
				}else if(this.addryForm.buyInsurance=='1'&&this.bxselectedValues.length==0){
						this.$message.error("请选择人员的保险类别");
					}else{
						
						//校验身份证是否合法,手机号是否合法
						this.addryForm.workerType=this.gwvalue
						if(this.bxselectedValues.length>0){
							this.addryForm.insurancetype=this.bxselectedValues.join(',')
						}
						
						this.$refs.addryForm.validate((valid) => {
							if (valid) {
								if(!this.isValidIdCard(this.addryForm.widNo)){
									this.$message.error("请输入有效的身份证号");	
								}else if(!this.isValidatePhone(this.addryForm.phone)){
									this.$message.error("请输入有效的手机号");	
								}else{
									this.$confirm('确认新增人员吗？', '提示', {}).then(() => {						
										addMember(this.addryForm).then((res) => {
											if(res.data.code==0){
												this.addryFormVisible = false;
												this.$message.success(res.data.message);
												this.getMemberList()
											}
											else{
												this.$message.error(res.data.message);
											}
										});
									});
								}

						
							}
						});
					}
			},	

			handleCurrentChange(val) {				
				this.page = val;
				this.getMemberList();
			},
			//获取用户列表
			getMemberList() {
				let para = {
					page: this.page,
					pageSize:20,
					coName: this.filters.companyName,
					coId:this.coId,
					objectId:this.objectId,
					workerName: this.filters.workerName,
					phone:this.filters.phone,
					widNo:this.filters.widNo,
					dvalue:this.filters.dvalue
				};

				this.listLoading = true;

				memberPageList(para).then((res) => {
					if(res.data.code==0){
						this.total = res.data.data.total;
						this.memberlist = res.data.data.list;
					}
					
					this.listLoading = false;

				});
			},
			
			
			handleEdit: function (index, row) {
				this.editForm.phone =row.phone
				this.editForm.workerType=row.workerType
				this.gwvalue=row.workerType

				this.editForm.workerId=row.workerId
				this.editFormVisible=true

				this.editFormTitle = "编辑【"+row.name+"】人员信息"
			},
			
			//编辑
			editMember: function () {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
						if(this.isValidatePhone(this.editForm.phone)){
							this.$confirm('确认提交吗？', '提示', {}).then(() => {
								this.editLoading = true;
								this.editForm.workerType=this.gwvalue
							
								editMemberInfo(this.editForm).then((res) => {
									this.editLoading = false;
									
									if(res.data.code==0){
										this.$message({
											message: '更新成功',
											type: 'success'
										});
										this.$refs['editForm'].resetFields();
										this.editFormVisible = false;
										this.getMemberList();
									}
									else{
										this.$message.error(res.data.message);
									}

								});
							});
						}else{
							this.$message.error("请输入有效的手机号");	
						}
					}
				});
			},
			handleDel: function (index, row) {
				this.$confirm('确认删除这个人员吗？', '提示', {}).then(() => {
					let para = {
						workerId: row.workerId
					};
					deleteMember(para).then((res) => {
						if(res.data.code==0){
							this.$message({
								message: '删除成功',
								type: 'success'
							});
							
							this.getMemberList();
						}
						else{
							this.$message.error(res.data.message);
						}

					});
				}).catch(() => {
  					// 用户点了取消 → 必须写 catch，否则控制台报错
					// this.$message.info('已取消');
				});

			},
			getRYGWdic() {
				let para={
					MpType:"RYGW",
					MpParentId:"1"
				}
				getparamsByType(para).then((res) => {
					if(res.data.code==0){
						this.gwoptions  =res.data.data
						this.gwvalue=this.gwoptions[0].MpValue

					}
				});
			},
			getKDRYBXdic() {
				let para={
					MpType:"KDRYBX",
					MpParentId:"178"
				}
				getparamsByType(para).then((res) => {
					if(res.data.code==0){
						this.bxoptions  =res.data.data
					}
				});
			},
			getcitiesbyprovince() {
				let para={
					MpType:"SSCC",
					MpParentId:14
				}
				getparamsByType(para).then((res) => {
					if(res.data.code==0){
						
						for (let index = 0; index < res.data.data.length; index++) {
							const element = res.data.data[index];
							if(element.MpValue==this.cvalue){
								this.cvalueid=element.Mpid
								break;
							}
						}
					
						this.getdistrictbycity()
					}
				});
			},
			getdistrictbycity() {
				let para={
					MpType:"SSCC",
					MpParentId:this.cvalueid
				}
				getparamsByType(para).then((res) => {
					if(res.data.code==0){
						this.doptions  =res.data.data
					}
				});
			},
			//导出excel
			handledc: function() {

				this.$confirm('确认导出人员表吗？', '提示', {}).then(() => {
					let para = {
						coName: this.filters.companyName,
						coId:this.coId,
						objectId:this.objectId,
						workerName: this.filters.workerName,
						phone:this.filters.phone,
						widNo:this.filters.widNo,
						dvalue:this.filters.dvalue
					};

					this.dcLoading = true;

					memberPageListdc(para).then(res => {
						this.dcLoading = false;

						if (res.data.code == 0) {
							//将data数据赋给exportList这个列表，用于当作导出Excel的数据源
							this.exportList = res.data.data;

							//开始执行导出方法，此方法要放在括号里面，因为是异步请求数据，请求完才能执行导出
							this.export2Excel();
						} 
						else {
							this.$message.error(res.data.message);
						}
					});
					
				}).catch(() => {
  					// 用户点了取消 → 必须写 catch，否则控制台报错
					// this.$message.info('已取消');
				});			
			},

			export2Excel() {
			require.ensure([], () => {
				const { export_json_to_excel } = require("@/vendor/Export2Excel");

				const tHeader = [
				"所属企业",
				"姓名",
				"性别",
				"身份证号",
				"手机号",
				"合同状态",
				"保险状态",
				"岗位",
				"入职时间",
				

				];

				const filterVal = [
				"coName",
				"name",
				"sexName",
				"widNo",
				"phone",
				"laborContractName",
				"insurancetypeName",
				"workerTypeName",
				"enterDate"
			
				];

				const list = this.exportList;

				const data = this.formatJson(filterVal, list);

				export_json_to_excel(
					tHeader,
					data,
					"人员表_" + moment(new Date()).format("YYYYMMDDHHmmss")
				);
			});
			},

			formatJson(filterVal, jsonData) {
			return jsonData.map(v => filterVal.map(j => v[j]));
			},
		},
		mounted() {			
			let user = JSON.parse(sessionStorage.getItem('user'));
			this.coId = user.data.coId
			this.objectId = user.data.userId

			if (user.data.roleId=="4") {
				this.filters.companyName = user.data.userName	
				this.bshow=true
				this.bquery=false
			} else {
				this.bquery=true
				this.bshow=false
			}

			//市局管理员支持按区查询
			this.cityFix=false
			if (user.data.roleId=="3") {
				this.cvalue= user.data.cityCode
				this.cityFix=true
				this.getcitiesbyprovince();
			}
			this.getMemberList();
			this.getRYGWdic();
			this.getKDRYBXdic();
		}
	}

</script>

<style scoped>

/* 增加样式，修复复选框第二行没对齐问题 */
.checkbox-wrapper :deep(.el-checkbox-group) {
  display: flex !important;
  flex-wrap: wrap !important;
  justify-content: flex-start !important; /* 强制左对齐 */
  align-items: center;
  gap: 16px 24px !important; /* 间距：上下16px，左右24px */
  width: 100% !important;
}

/* 单个复选框：固定宽度，保证每行4个且对齐 */
.checkbox-item {
  width: calc(25% - 18px) !important; /* 25%=每行4个，减间距补偿 */
  min-width: 110px !important;
  margin: 0 !important; /* 清除Element默认margin */
  padding: 0 !important;
  line-height: 32px !important;
  box-sizing: border-box !important;
}
</style>


// WEBPACK FOOTER //
// enterpriseMember.vue?86d27cc8